import React from "react";
import { ColumnType } from "antd/lib/table";
import { EMPTY } from "constants/common";
import { AICC_CONVERSATION_TYPE } from "constants/aicc";
import { AiccConversation } from "types/model/aiccCustomer";
import ConversationHistory from "../ConversationHistory";
import { conversationIdColumn } from "../ConversationHistory/columnConfig";

interface Props {
  subUserId: string;
  languageId: number;
}

const leadingColumns: ColumnType<AiccConversation>[] = [
  {
    title: "Level and Lesson",
    dataIndex: "title",
    key: "title",
    width: 240,
    ellipsis: true,
    render: (_, { title }) => title || EMPTY,
  },
  {
    title: "Lesson Review Index",
    dataIndex: "scriptIndex",
    key: "scriptIndex",
    width: 180,
    ellipsis: true,
    render: (_, { scriptIndex }) => scriptIndex ?? EMPTY,
  },
  conversationIdColumn,
];

function LessonReview({ subUserId, languageId }: Props) {
  return (
    <ConversationHistory
      subUserId={subUserId}
      languageId={languageId}
      title="Lesson Review Conversation History"
      conversationType={AICC_CONVERSATION_TYPE.lessonReview}
      leadingColumns={leadingColumns}
    />
  );
}

export default LessonReview;
